<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="8"
      >
        <v-card flat class="mb-4">
          <v-card-title class="subheading font-weight-bold justify-left">
            Thông tin chung
          </v-card-title>
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="7">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">Loại:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.the_loai_id==0 ? 'cần mua' : 'cần bán'}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">Người đăng:</v-list-item-content>
                    <v-list-item-content class="align-end" v-if="item.user">
                      {{item.user.name}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">Địa chỉ:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.dia_chi}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="item.loaiCoSoCungCapGiong">
                    <v-list-item-content class="font-weight-bold">Điện thoại:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.so_dien_thoai}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="item.nltsChuLuc">
                    <v-list-item-content class="font-weight-bold">Giá tham khảo:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.giaca > 0 ? item.giaca : 'Liên hệ'}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-bold">Ngày đăng:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.ngay_dang}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Ngày hết hạn:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.ngay_het_han}}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" sm="12" md="5">
                <v-carousel
                  v-if="item.images && item.images.length > 0"
                  height="250"
                  hide-delimiter-background
                  class="cara"
                >
                  <v-carousel-item
                    eager
                    v-for="img in item.images"
                    :key="img.id"
                    :src="`${apiBaseUrl}/uploads/${img.path}`"
                  />
                </v-carousel>
                <v-img
                  v-else-if="item.anh_dai_dien"
                  height="250"
                  :src="`${apiBaseUrl}/uploads/${item.anh_dai_dien}`"
                />
                <v-img
                  v-else
                  height="250"
                  src="@/assets/NoImage.jpg"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-row>
          <v-col cols="12">
            <v-card flat>
              <v-card-title class="subheading font-weight-bold justify-left">
                Nội dung
                <v-spacer/>
                <v-btn icon @click="moreInfoShow=!moreInfoShow">
                  <v-icon>mdi-chevron{{moreInfoShow ? '-up' : '-down'}}</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text v-if="moreInfoShow" v-html="item.noi_dung"/>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer/>
      <v-col
        cols="12"
        sm="12"
        md="4"
      >
        <v-card flat>
          <v-card-text class="text-center">
            <span class="text-h6 font-weight-bold">
              Tin khác
            </span>
          </v-card-text>
          <v-card-text class="text-center" v-if="relatedItems.length == 0">
            <span>
              Không tìm thấy bản tin liên quan
            </span>
          </v-card-text>
          <v-card-text>
            <v-row>
              <v-card 
                flat 
                v-for="(related_item, index) in relatedItems"
                :key="index"
                :to="{ name: 'BusinessView', params: { id: related_item.id }}"
                class="px-6"
              >
                <div class="d-flex flex-no-wrap">
                  <v-avatar
                    class="ma-3 rounded-lg"
                    size="100"
                    tile
                  >
                    <v-img
                      v-if="related_item.logo"
                      :src="related_item.logo"
                    />
                    <v-img 
                      v-else
                      src="@/assets/NoImage.jpg"
                    />
                  </v-avatar>
                  <div>
                    <v-card-title class="text-h6 pb-1">
                      {{related_item.tieu_de}}
                    </v-card-title>
                    <v-card-text>
                      <div class="text-body-2 mb-2">
                        <v-icon 
                          color="orange"
                          small 
                          left
                        >
                          mdi-circle
                        </v-icon>
                        <span v-if="related_item.the_loai_id == 0">Cần mua</span>
                        <span v-else>Cần bán</span>
                      </div>
                      <div class="text-body-2">
                        <v-icon small left>
                          mdi-calendar
                        </v-icon>Hết hạn ngày: {{related_item.ngay_het_han}}
                      </div>
                    </v-card-text>
                  </div>
                </div>
              </v-card>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <Message 
      :showDialog="messageDialog" 
      :sanPhamId="String($route.params.id)"
      @confirmed="onMessageConfirmed" 
      @cancelled="onMessageCancelled"
    />
  </v-container>
</template>
<script>
  import Message from '@/views/public/trades/TradeMessage';
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import { mapState } from 'vuex';
  export default {
    components: {
      Message,
      BaseBreadcrumbs
    },
    data: () => ({
      loading: false,
      crumbs: [],
      item: {},
      messageDialog: false,
      relatedItems: [],
      moreInfoShow: true,
    }),
    computed: {
      ...mapState([
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    watch: {
      "$route.params.id": function() {
        this.initialize();
        this.getRelatedItems();
      }
    },
    mounted() {      
      this.getRelatedItems();
      this.initialize();
    },
    methods: {
      initialize(){
        const app = this;
        app.loading=true;
        axios.get(`api/v1/public/trades/${app.$route.params.id}`)
          .then(response => {
            app.item = response.data;
            app.crumbs = [
              {
                text: 'Trang chủ',
                disabled: false,
                href: '/',
              },
              {
                text: 'Tin cung cầu',
                disabled: false,
                href: '/trades',
              },
              {
                text: app.item.tieu_de,
                disabled: true
              }
            ];
            app.loading=false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getRelatedItems(){
        axios.get(`api/v1/public/trades-related/${this.$route.params.id}`)
          .then(response => {
            this.relatedItems = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      showMessageDialog(item=null){
        this.messageDialog = true;
      },
      onMessageConfirmed(item) {
        this.messageDialog = false;
      },
      onMessageCancelled () {
        this.messageDialog = false;
      },
    }
  }
</script>

<style scoped>
  .v-card--flat {
    box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12) !important;
  }
</style>